export default "__VITE_ASSET__DsawnghN__"